import React from "react";
import InfoForm from "../components/InfoForm";
import List from "../components/List";

function Pricing() {
  const devices = [
    {
      key: "1",
      name: "Projectors",
      list: [
        "Standard 3000 (3K) Lumens",
        "Premium 3500 (3.5K) Lumens",
        "4,000 Lumens HD Projector",
        "6,000 Lumens HD Projector",
        "8,000 Lumen HD Projector",
        "12,000 Lumen HD Projector",
        "16,000 Lumen HD Projector",
        "20,000 Lumen HD Projector",
      ],
      attention: "16,000 and up requires 220 volt power",
    },
    {
      key: "2",
      name: "LCD / LED Monitors",
      list: [
        '32" HD Monitor',
        '42" HD Monitor',
        '55" HD Monitor',
        '60" HD Monitor',
        '70" HD Monitor',
        '90" HD Monitor',
      ],
    },
    {
      key: "3",
      name: "Touchscreen Monitors",
      list: [
        '42" Touchscreen Monitor',
        '46" Touchscreen Monitor',
        '55" Touchscreen Monitor',
        '65" Touchscreen Monitor',
        "Tabletop Touchscreen",
      ],
    },
    {
      key: "4",
      name: "LED / Video Walls",
      list: [""],
      attention: "Contact us for availability",
    },
    {
      key: "5",
      name: "Screen Rental",
      list: ["4:3", `6' Tripod Screen`, `8' Tripod Screen`],
    },
    {
      key: "6",
      name: "Fast Fold Screens",
      list: [
        `16:9 (Dress Kit Separate)`,
        `5'5" x 10' HD Screen`,
        `7.5' x 14 HD Screen`,
        `9' x16' HD Screen`,
        `11.5 x 20' HD Screen`,
      ],
      attention: "Choice of front or rear projection",
    },
    {
      key: "7",
      name: "Truss Screens",
      list: [
        `10' x 30' Front/Rear Projection Truss (w/legs)`,
        `11.5' x 20' 3D Rear Projection Fast fold Screen`,
        `20' Widescreen Front Projection Truss`,
        `11.3' x 20' viewing area Choice of front or rear projection`,
      ],
      attention: "* Dress Kit Separate",
    },
    {
      key: "8",
      name: "Lighting",
      list: [
        "Custom Gobo",
        "Dimmer Pack",
        "DMX Controller Boards",
        "Custom DMX Programming",
        "LED Uplight (Wired and Battery Operated)",
        "Intelligent Lighting",
        "LED Pars",
        "Source 4 Leko",
        "Pinspot",
        "Laser",
      ],
    },
    {
      key: "9",
      name: "Communication Equipment",
      list: [
        "Video Conferencing HD Solutions Camera and Courtroom Solutions PC Rentals and Printer.",
      ],
    },
    {
      key: "10",
      name: "Presentation Rentals",
      list: [
        "Flip Charts",
        "AV Carts",
        "Laser Pointers",
        "Teleprompter",
        "Signage Easels",
        "Speaker Timers",
        "and more!",
      ],
    },
    {
      key: "11",
      name: "Speakers and PA Rentals",
      list: [],
    },
    {
      key: "12",
      name: "",
      list: [
        "We have a huge availability of speakers and PA System rentals. QSC, JBL, L'Acoustic Line Arrays, Powered speakers, Band PA, Meeting PA, etc.  Just Ask!",
      ],
    },
    {
      key: "13",
      name: "Microphones",
      list: [
        "Tabletop Microphone",
        "Wired Handheld Microphone",
        "Wireless Handheld Microphone",
        "Wireless Handheld and Lapel Combo",
        "Countryman Headset",
        "Gooseneck Podium Microphone",
        "Delegate Conference Wireless System",
        "Drum Kits are also available",
      ],
    },
    {
      key: "14",
      name: "Mixing Board & Auxiliary Rental",
      list: [
        "Soundcraft 8, 16, 32 channel analog",
        "Behringer 32 channel",
        "(Other brands and channel variations available)",
        "Digital recording Kit",
        "Active and Passive Multi Box",
      ],
    },
    {
      key: "15",
      name: " Pipe and Drape (and Set Pieces)",
      list: [
        "(black and blue kept in stock) Other available colors: White, Gray or Multi",
      ],
    },
    {
      key: "16",
      name: "Stage Rental and Lectern Rental",
      list: [
        "We have both indoor and outdoor staging in various available configurations. Indoor decks are 4 x 8 decks put together to your custom configuration.",
      ],
    },
    {
      key: "17",
      name: "",
      list: [],
    },
  ];

  return (
    <div>
      <div className="bg-white dark:bg-gray-900 dark:text-gray-300 md:flex md:flex-row text-center px-2">
        {/* Left Side */}
        <div className="sm:basis-2/4  lg:basis-2/6 md:overflow-auto  md:h-screen shadow-lg md:bg-gray-800 rounded-lg ">
          <div className="px-2">
            <p className="mb-4 text-3xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white md:text-center sm:pt-10">
              Product Catalog
            </p>
            <p className="mb-8 lg:mb-16 font-light dark:text-red-600 text-gray-500 dark:text-gray-400 sm:text-xl md:text-center">
              Get a custom quote! (123)-456-7890
            </p>
            {devices.map((item) => (
              <List
                key={item.key}
                name={item.name}
                items={item.list}
                attention={item.attention}
              />
            ))}
            <p className="dark:text-red-600 text-sm m-4 pb-4">
              We have much more - too much to name. Please call today for more
              information or fill out our price request form above. xxx-xxx-xxxx
            </p>
            {/* End of Left side */}
          </div>
        </div>
        {/* Right Side */}
        <div className="basis-3/4 ml-10 mr-2 ">
          <InfoForm />
        </div>
      </div>
    </div>
  );
}

export default Pricing;
